import { Typography } from '@mui/material'
import ApiClient from '../../backend/ApiClient'
import ActivityManager from '../../managers/ActivityManager'
import { useAppDispatch, useAppSelector } from '../../store/Hooks'
import { changeRoute } from '../../store/slices/SessionSlice'
import RouteHeader from '../controls/RouteHeader'
import SmartCard from '../controls/cards/SmartCard'
import StaleObserver from '../controls/stale/StaleObserver'
import { SmartTableUtilities } from '../controls/table'
import SmartTable from '../controls/table/SmartTable'
import useQuery, { buildQueryKey } from '../hooks/useQuery'
import Tile from '../layout/Tile'
import RoutingManager from '../routing/Routing'

export default function CounterpartyDetails() {
    const dispatch = useAppDispatch()
    const params = RoutingManager.getParams<{ counterpartyId: number, contractId: number }>(useAppSelector(s => s.session.routeParams))

    const { status, response } = useQuery({
        queryKey: buildQueryKey('provider-group-details', params.counterpartyId),
        queryFn: async () => await ApiClient.getCounterpartyDetails(params.counterpartyId),
        cache: true
    })

    const isLoading = status === 'loading'

    return (
        <Tile.Container>
            <RouteHeader
                isLoading={isLoading}
                primary={response?.name}
                secondary='Provider Group'
                subActions={[
                    { label: 'Updated last week', icon: 'clock', onClick: () => ActivityManager.openActivity('counterparties') }
                ]}
            />
            <Typography></Typography>
            <SmartCard flex={1} style={{ overflowY: 'auto' }}>
                <SmartTable
                    columns={[
                        { id: 'name', label: 'Name' }
                    ]}
                    isLoading={isLoading}
                    noCollapse
                    onClickRow={i => dispatch(changeRoute({ route: 'provider', params: { providerId: response?.providers[i].id, contractId: params.contractId }, customRouteName: response?.providers[i].name }))}
                    datasource={{ rows: (response?.providers ?? [])?.map((x, i) => SmartTableUtilities.toRow([{ value: x?.name }], i)) }}
                />
            </SmartCard>
            <StaleObserver status={status} />
        </Tile.Container>
    )
}
